import FBtnMDP, { BtnType } from '@/components/FBtnMDP';
import FFormSubmitBtnMDP from '@/components/FFormSubmitBtnMDP';
import FFormMDP, { FFormChildMDP } from '@/components/form/FFormMDP';
import FCurrencyFieldMDP from '@/components/form/field/FCurrencyFieldMDP';
import FEmailFieldMDP from '@/components/form/field/FEmailFieldMDP';
import FPhoneFieldMDP from '@/components/form/field/FPhoneFieldMDP';
import FSelectFieldMDP from '@/components/form/field/FSelectFieldMDP';
import FTextFieldMDP from '@/components/form/field/FTextFieldMDP';

export default class AddPartnerClientFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  root: any;
  title: string = "Enter Mobile Number";
  // parent: any;
  constructor({ root }: { root: any }) {
    super({
      myRefName: 'addPartnerClientFFormRef',
    });
    this.root = root;
    // this.parent = parent;

    this
      .addField(
        new FPhoneFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: 'mobile',
          label: 'Mobile',
          mandatory: true,
          boundaryClass: 'col-3',
        })
      )
      .addAction(
        new FBtnMDP({
          label: 'cancel',
          btnType: BtnType.TEXT,
          onClick: () => this.root.resetDsaClientDraftClientform(),
        })
      )

      .addAction(
        new FFormSubmitBtnMDP({
          label: 'Add client',
          onClick: () => this.root.addDsaClientDraft(),
        })
      );
  }

  getMyRef(): any {
    return this.root.$refs[this.myRefName];
  }

  getMetaData(): object {
    const metaData = super.getMetaData();
    (metaData as any).props.title = this.title;
    return metaData;
  }
}
